export default "__VITE_ASSET__BkMvKImZ__"